export default "__VITE_ASSET__BIYRrfwp__"